// "ap-southeast-2" is the AWS single-region deployment value (D6); the two
// GCP values remain in the union for local dev (.env REGION=us-central1) and
// GCP-era data (WorkOS metadata, workspace-region cache, relocation stamps).
export const SUPPORTED_REGIONS = [
  "europe-west1",
  "us-central1",
  "ap-southeast-2",
] as const;
export type RegionType = (typeof SUPPORTED_REGIONS)[number];

export interface RegionInfo {
  name: RegionType;
  url: string;
}

export function isRegionType(region: string): region is RegionType {
  return SUPPORTED_REGIONS.includes(region as RegionType);
}
